import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AppManager from "../../../managers/AppManager";
import RouteManager from "../../../managers/RouteManager";
import { fetchLocationList, selectLocationList } from "../../../Redux/Slices/LocationListSlice";
import TimesheetService from "../TimesheetService";
import TimesheetUtils from "../TimesheetUtils";
import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";

import {
    removeLoader,
    showLoader,
    showToast,
    TOAST_TYPE,
    INPUT_TYPE
} from "deskera-ui-library";
import AddProject from "./AddProject";
import { fetchBooksContact, selectBooksContact } from "../../../Redux/Slices/BooksContactSlice";
import Utility from "../../../utility/Utility";
import { fetchProject, selectProject } from "../../../Redux/Slices/ProjectSlice";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import { parseColumnConfig, parseVisibleColumnConfig } from "../../configs/config";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";

function Projects(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const booksContact = useSelector(selectBooksContact);
    const project = useSelector(selectProject);
    
    const locations = useSelector(selectLocationList);

    const [showAddProject, setShowAddProject] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [projectData, setProjectData] = useState({
        columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_PROJECT), TABLES.PEOPLE_PROJECT)),
        rowData: [],
        filter: [],
        originalData: []
    });
    const [fetchingDependencies, setFetchingDependencies] = useState(true);
    const [reload, setReload] = useState(false);
    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();
        
        fetchDependencies();
    }, []);

    useEffect(() => {
        if (!fetchingDependencies) {
            getProjects();

            const columns = parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_PROJECT), TABLES.PEOPLE_PROJECT));
            if(booksContact) {
                const index = columns.findIndex((column) => column.columnCode === 'customer');
                if(index !== -1) {
                    columns[index].options = booksContact?.map((contact) => {
                        return {
                            ...contact,
                            label: contact.name,
                            value: contact.customer,
                            id: contact.id.toString()
                        }
                    }) || [];
                }
            }

            if (locations && TimesheetUtils.isTrackLocation()) {
                const options = locations.map((location) => {
                    return {
                        id: location.id,
                        name: location.label
                    };
                });

                columns.push({
                    type: INPUT_TYPE.SELECT,
                    name: TimesheetUtils.getLocationLabel(),
                    key: "location",
                    columnCode: "location",
                    options: options,
                    width: 200
                });
            }

            setProjectData({
                ...projectData,
                columnData: columns
            });
        }
    }, [fetchingDependencies, booksContact, locations, reload]);

    useEffect(() => {
        if(!Utility.isEmpty(project)) {
            if(project.data) {
                if (project.data.length > 0) {
                    const rowData = TimesheetUtils.getProjectsRowData(project.data);
                    setProjectData({
                        ...projectData,
                        rowData: rowData,
                        originalData: rowData
                    });
                } else {
                    setProjectData({
                        ...projectData,
                        rowData: [],
                        originalData: []
                    });
                }
            }
            
        }
    }, [project]);

    const fetchDependencies = async() => {   
        showLoader();     
        const dependencies = [dispatch(fetchBooksContact())];
        if (TimesheetUtils.isTrackLocation()) {
            dependencies.push(dispatch(fetchLocationList()));
        }

        await Promise.all(dependencies);
        setFetchingDependencies(false);
        removeLoader();
    }

    const getProjects = async() => {
        showLoader();
        await dispatch(fetchProject());
        removeLoader();
    }

    const onRowEdit = (data) => {
        if (data?.rowData) {
            TimesheetService.PROJECT = data.rowData.project;
            setShowAddProject(true);
        }
    }

    const onRowDelete = (data) => {
        if (data?.rowData) {
            showLoader("Deleting project... Please wait");
            const payload = {
                id:data.rowData.id
            }
            TimesheetService.deleteProject(payload).then(res=>{
                getProjects();
                removeLoader();
                showToast("Project deleted successfully.", TOAST_TYPE.SUCCESS);
            },error=>{
                removeLoader();
                const message = error && error.message ? error.message : t("SOMETHING_WENT_WRONG")
                showToast(message, TOAST_TYPE.FAILURE);
            })
        }
    }

    return (
        <Fragment>
            {showAddProject &&
                <AddProject
                    onClose={(refresh) => {
                        setShowAddProject(false);
                        if (refresh) {
                            getProjects();
                        }
                    }}
                />
            }
            <div>
                <DataGridHolderPayroll
                    tableName={TABLES.PEOPLE_PROJECT}
                    displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_PROJECT]}
                    allowBulkOperation={true}
                    allowColumnEdit={false}
                    allowColumnDelete={false}
                    allowColumnShift={false}
                    allowSearch={false}
                    allowFilter={false}
                    allowColumnAdd={false}
                    allowRowAdd={false}
                    allowColumnSort={false}
                    refresh={false}
                    allowDataExport={false}
                    allowRowEdit={PermissionUtils.hasAccess(MODULE.TIMESHEET, [ACTION.EDIT])}
                    showContextEdit={false}
                    contextMenu={true}
                    isMenuVisible={false}
                    showContextMenu={true}
                    isActionEnabled={true}
                    gridData={projectData}
                    currentPage={currentPage}
                    totalPageCount={totalPageCount}
                    onRowEdit={(data) => {
                        onRowEdit(data);
                    }}
                    onRowDelete={(data) => {
                        onRowDelete(data);
                    }}
                    onPaginationClick={(requestedPageNumber) => {
                        setCurrentPage(requestedPageNumber);
                    }}
                    addButtonConfig={[{
                        title: `+ ${"Project"}`,
                        className: "bg-app text-white ml-s",
                        onClick: () => {
                            setShowAddProject(true);
                        }
                    }]}
                    onColumnShift={(data)=> setReload(!reload)}
                    module={MODULE.TIMESHEET}
                />
            </div>
        </Fragment>
    );
}

export default Projects;
